import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _cached = null;

function applyFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}

/**
 * Fetches global store settings (logo_url, favicon_url, etc.) once and caches.
 * Also injects favicon_url into the document <head> automatically.
 */
export function useStoreSettings() {
  const [settings, setSettings] = useState(_cached);

  useEffect(() => {
    if (_cached) {
      setSettings(_cached);
      applyFavicon(_cached.favicon_url);
      return;
    }
    axios.get(`${API}/settings`).then(res => {
      _cached = res.data;
      setSettings(res.data);
      applyFavicon(res.data.favicon_url);
    }).catch(() => {});
  }, []);

  return settings;
}

/** Call to invalidate cache after saving new settings */
export function invalidateStoreSettings() {
  _cached = null;
}
